<template>
  <back-office-form
    :inputs="inputs"
    :item="integration"
    :delete-button-label="this.$t('integrations.delete')"
    delete-confirmation-attribute="name"
    :mode="mode"
    :modes="modes"
    @submit="handleSubmit"
    @delete="handleDelete"
  />
</template>

<script>
  import BridgeSelect from './BridgeSelect'
  import CasinoSelect from './CasinoSelect'
  import BackOfficeForm from '@/components/BackOfficeForm'
  import IntegrationProperties from "@/components/IntegrationProperties";
  import IntegrationCasinos from "@/components/IntegrationCasinos";

  export default {
    name: 'IntegrationForm',
    components: { BackOfficeForm },
    props: {
      integration: {
        type: Object,
        default: () => {
          return {}
        }
      },
      mode: {
        type: String,
        required: true
      }
    },
    methods: {
      handleSubmit (...rest) {
        this.$emit('submit', ...rest)
      },
      handleDelete () {
        this.$emit('delete')
      }
    },
    computed: {
      modes () {
        return {
          create: {
            title: 'integrations.add',
            subtitles: ['integrations.addDescription']
          },
          edit: {
            title: 'integrations.edit',
            subtitles: ['']
          }
        }
      },
      inputs () {
        return [
          {
            name: 'name',
            validators: 'required',
            properties: {
              placeholder: this.$t('integrations.newIntegrationPlaceholder'),
              label: this.$t('common.name'),
            }
          },
          {
            name: 'integrationId',
            validators: 'required',
            properties: {
              placeholder: this.$t('integrations.idPlaceholder'),
              label: this.$t('integrations.id'),
            }
          },
          {
            name: 'gameRoundValidityPeriod',
            validators: 'min_value:1',
            properties: {
              label: this.$t('integrations.gameRoundValidityPeriod'),
              help: this.$t('integrations.gameRoundValidityPeriodHelp')
            }
          },
          {
            name: 'bridgeId',
            is: BridgeSelect,
            validators: 'required',
            properties: {
              placeholder: this.$t('common.bridge'),
              label: this.$t('common.bridge')
            }
          },
          {
            name: 'defaultCasinoId',
            is: CasinoSelect,
            properties: {
              nullable: true,
              placeholder: this.$t('integrations.defaultCasinoIdPlaceHolder'),
              label: this.$t('integrations.defaultCasinoId')
            }
          },
          {
            name: 'properties',
            is: IntegrationProperties,
            properties: {
              label: this.$t('common.properties'),
            }
          },
          {
            name: 'casinos',
            is: IntegrationCasinos,
            properties: {
              label: this.$t('common.casinos'),
            }
          },
        ]
      }
    }
  }
</script>

<style scoped>
</style>
